import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useAccount } from "wagmi";

export interface Deposit {
  leaf_type: number;
  orig_net: number;
  orig_addr: string;
  amount: string;
  dest_net: number;
  dest_addr: string;
  block_num: string;
  deposit_cnt: string;
  network_id: number;
  tx_hash: string;
  claim_tx_hash: string;
  metadata: string;
  ready_for_claim: boolean;
  global_index: string;
}

export interface BridgeApiResponse {
  deposits: Deposit[];
  total_cnt: string;
}

const fetchBridges = async (address?: string): Promise<BridgeApiResponse> => {
  const response = await axios.get<BridgeApiResponse>(
    `/api/bridges/${address}`,
    {
      params: {
        limit: 100,
        offset: 0,
      },
    }
  );
  return response.data;
};

export const useBridges = () => {
  const { address } = useAccount();

  return useQuery({
    queryKey: ["bridges", address],
    queryFn: () => fetchBridges(address),
    enabled: !!address,
    retry: 3,
    refetchOnWindowFocus: true,
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
  });
};
